<template>
    <div class="notice-page">
        <div class="notice-container">
            <!-- 头部 -->
            <div class="notice-header">
                <h2 class="notice-title">"智瞰·项目雷达"产品使用规范告知书</h2>
                <p class="notice-subtitle">（在线签署版）</p>
            </div>

            <!-- 内容区域 -->
            <el-scrollbar class="notice-content-wrap">
                <div class="notice-content">
                    <p class="greeting">尊敬的 {{userdata.crmName || userdata.username}} ：</p>
                    <p class="paragraph">
                        为保障"智瞰·项目雷达"系统的安全运行及各方合法权益，请您在使用前仔细阅读并遵守以下规范。您在线勾选"同意"或实际使用本系统，即视为已充分理解并接受本告知书全部内容。
                    </p>

                    <h4>一、账号使用</h4>
                    <p class="paragraph">1. 账号实行实名开通，仅限您本人因本单位业务使用，不得转让、出租、出借或以其他方式提供给任何第三方；</p>
                    <p class="paragraph">2. 请妥善保管账号密码，如发现异常登录或泄露风险，请立即联系客服；使用人离职或调岗的，所属单位应及时通知我方注销账号。</p>

                    <h4>二、使用行为规范</h4>
                    <p class="paragraph warning-text">严禁以下行为：</p>
                    <p class="paragraph font-weight">1. 对系统进行反向工程、反编译、反汇编、解密，或以其他方式试图获取源代码、底层架构、数据库结构、数据接口等技术信息；</p>
                    <p class="paragraph font-weight">2. 使用爬虫程序、脚本、机器人等自动化工具，对系统数据进行批量采集、下载、复制、转移或存储；</p>
                    <p class="paragraph font-weight">3. 绕过或破坏访问控制、频率限制、验证码等技术保护措施，获取超出正常权限的数据或服务；</p>
                    <p class="paragraph font-weight">4. 将系统数据（包括但不限于项目审批信息、企业信息、研究报告内容）向第三方提供、出售、出租、转让，或用于构建与我方产品相竞争的数据库或信息系统；</p>
                    <p class="paragraph font-weight">5. 利用系统数据从事任何违法违规活动，或实施损害我方及第三方合法权益的行为。</p>

                    <h4>三、知识产权与数据使用</h4>
                    <p class="paragraph">
                        本系统全部知识产权归<strong>深圳市智瞰商讯科技有限公司</strong>所有。系统数据仅供贵单位经营参考，可在内部合理使用，不得对外发布、出售或向第三方提供。
                    </p>

                    <h4>四、违规处理</h4>
                    <p class="paragraph">
                        违反上述规范的，我方有权视情节采取警示、暂停或永久终止账号等措施；造成损失的，应依法承担赔偿责任；涉嫌违法犯罪的，我方保留追究法律责任的权利。
                    </p>

                    <p class="paragraph highlight">
                        本告知书自您在线勾选"同意"并提交之日起生效，勾选"同意"则表示您已全文阅读并同意遵守上述规范。
                    </p>

                    <div class="company-sign">
                        <p>深圳市智瞰商讯科技有限公司</p>
                    </div>
                    <div class="company-sign">
                        <!-- 年月日 -->
                        <p>{{ new Date().getFullYear() }}年{{ new Date().getMonth() + 1 }}月{{ new Date().getDate() }}日</p>
                    </div>
                </div>
            </el-scrollbar>

            <!-- 底部操作栏 -->
            <div class="notice-footer">
                <el-checkbox v-model="agreed" class="agree-checkbox">
                    我已阅读并同意上述规范
                </el-checkbox>
                <el-button type="primary" :disabled="!agreed || countdown > 0 || loading" :loading="loading"
                    class="submit-btn" @click="handleSign">
                    {{ countdown > 0 ? `确认签署（${countdown}秒）` : '确认签署' }}
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { signNotice } from '@/utils/utils.js'  // 导入签署接口函数

export default {
    name: 'ProductNotice',
    data() {
        return {
            userdata:{username:''},
            agreed: false,
            loading: false,
            countdown: 5,
            timer: null
        }
    },
    mounted() {
        this.userdata = this.getuseriformation() || {};
        this.startCountdown()
    },
    beforeDestroy() {
        this.clearCountdown()
    },
    methods: {
        startCountdown() {
            this.clearCountdown()
            this.countdown = 5
            this.timer = setInterval(() => {
                this.countdown--
                if (this.countdown <= 0) {
                    this.clearCountdown()
                }
            }, 1000)
        },
        clearCountdown() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        },
        async handleSign() {
            if (!this.agreed) {
                this.$message.warning('请先阅读并同意上述规范')
                return
            }

            this.loading = true
            try {
                await signNotice();
                this.$message.success('签署成功，感谢您的配合！');

                // ✅ 关键：立即更新缓存，否则守卫会把你拦回来
                sessionStorage.setItem('productNoticeSigned', 'true');

                const redirect = this.$route.query.redirect || '/'
                this.$router.replace(redirect)
            } catch (error) {
                this.$message.error(error.message || '签署失败，请稍后重试')
            } finally {
                this.loading = false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.font-weight {
    font-weight: bold;
}
.notice-page {
    background: #f0f2f5;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding: 40px 20px;
}

.notice-container {
    width: 100%;
    max-width: 1200px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 80px);
    overflow: auto;
}

.notice-header {
    text-align: center;
    padding: 30px 40px 20px;
    border-bottom: 1px solid #ebeef5;
    flex-shrink: 0;

    .notice-title {
        font-size: 22px;
        font-weight: bold;
        color: #303133;
        margin: 0 0 8px;
    }

    .notice-subtitle {
        font-size: 16px;
        color: #909399;
        margin: 0;
    }
}

.notice-content-wrap {
    flex: 1;
    overflow-y: auto;

    ::v-deep .el-scrollbar__wrap {
        overflow-x: hidden;
    }
}

.notice-content {
    padding: 24px 40px;
    font-size: 16px;
    line-height: 1.8;
    color: #303133;

    .greeting {
        font-weight: bold;
        color: #303133;
    }

    h4 {
        font-size: 16px;
        color: #303133;
        margin: 20px 0 10px;
        font-weight: bold;
    }

    .paragraph {
        margin: 8px 0;
        text-indent: 2em;
        text-align: justify;

        &.warning-text {
            color: #f56c6c;
            font-weight: bold;
            text-indent: 0;
        }

        &.highlight {
            font-weight: bold;
            color: #303133;
            margin-top: 20px;
        }
    }

    .company-sign {
        text-align: right;
        margin-top: 30px;
        padding-right: 20px;
        font-weight: bold;
        color: #303133;
    }
}

.notice-footer {
    padding: 20px 40px;
    border-top: 1px solid #ebeef5;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    background: #fafafa;
    border-radius: 0 0 8px 8px;

    .agree-checkbox {
        ::v-deep .el-checkbox__label {
            font-size: 16px;
            color: #303133;
        }

        ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
            color: #409eff;
        }
    }

    .submit-btn {
        width: 160px;
    }
}

// 移动端适配
@media screen and (max-width: 768px) {
    .notice-page {
        padding: 0;
        background: #fff;
    }

    .notice-container {
        max-height: 100vh;
        border-radius: 0;
        box-shadow: none;
    }

    .notice-header {
        padding: 20px 20px 15px;

        .notice-title {
            font-size: 18px;
        }
    }

    .notice-content {
        padding: 16px 20px;
    }

    .notice-footer {
        padding: 15px 20px;
        flex-direction: column;
        gap: 12px;

        .submit-btn {
            width: 100%;
        }
    }
}
</style>